///<reference path="../../employee/sections/employee.main.section.ts"/>
module Meevo.Plugins.Student {
    'use strict';

    /**
    * Main Section of Employee 
    */
    export class MainSection extends Meevo.Plugins.Employee.MainSection{
        public get auditNounForSave() {
            return Model.NounEnum.Student;
        }

        public preSave() {
            this.model.employeeEntityTypeEnum = Meevo.Model.EmployeeEntityTypeEnum.Student;

            super.preSave();
        }
    }
}